<template>
  <div id="app">
    <router-view/>
    <input id="custom_copyInput" style='opacity: 0;position: absolute;' type="text"></input>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('mouseup', (event) => {
        let input = document.getElementById("custom_copyInput")
        let txt = window.getSelection ? window.getSelection().toString() : document.selection.createRange().text
        if (txt && txt !== '') {
          input.value = txt
        }
      })
    })
  }
}
</script>

<style lang="less">
.size{
  width: 100%;
  height: 100%;
}
html,body{
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
</style>
